import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, Suspense } from "react";

import PageNotFound from "./ErrorPage";
import { useAppHooks } from "./app.hooks";

const AccountRoutes = lazy(
  () => import("./account-information/account.routes"),
);
const OnboardingRoutes = lazy(() => import("./onboarding/onboarding.routes"));
const AccountStatusRoutes = lazy(
  () => import("./account-status/account-status.routes"),
);

export default function AppRoutes() {
  useAppHooks();

  return (
    <Suspense fallback={<>loading page...</>}>
      <Routes>
        <Route path="/" element={<Navigate to="/shipping" replace />} />
        <Route path="shipping">
          <Route index element={<></>} />
          <Route path="onboarding/*" element={<OnboardingRoutes />} />
          <Route path="account-status/*" element={<AccountStatusRoutes />} />
          <Route path="account-information/*" element={<AccountRoutes />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Suspense>
  );
}
